import { render, staticRenderFns } from "./zypx.vue?vue&type=template&id=23cbd7dd&scoped=true"
import script from "./zypx.vue?vue&type=script&lang=js"
export * from "./zypx.vue?vue&type=script&lang=js"
import style0 from "./zypx.vue?vue&type=style&index=0&id=23cbd7dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cbd7dd",
  null
  
)

export default component.exports